import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

export interface Product {
  _id: string;
  title: string;
  slug: string;
  price: number;
  imageUrl?: string;
  images?: Array<{ url: string; altText?: string; isDefault?: boolean }>;
}

export interface ProductResponse {
  success: boolean;
  data: Product[];
}

class ProductService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getProductsByCategory(categorySlug: string): Promise<ProductResponse> {
    return this.__Apiservice.getRequest(`products/category/${categorySlug}`, {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

const productService = new ProductService();
export default productService;
